import * as React from 'react';
import styled from 'styled-components';

import { Card, Text } from '~/styles';

interface DetailsCardProps {
  details: {
    label: string;
    value: string;
  }[];
}

const DetailWrapper = styled.div`
  background: ${({ theme }) => theme.body};
  break-inside: avoid;
  padding: 12px 16px;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  border-top: 1px solid ${({ theme }) => theme.secondary.blendToBackground(150)};

  &:first-child {
    border-top: none;
  }
`;

const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.body};
  overflow: hidden;
  container-type: inline-size;
`;

const DetailsGrid = styled.div`
  display: grid;
  gap: 0 1px;
  background-color: ${({ theme }) => theme.secondary.blendToBackground(200)};
  grid-auto-flow: row;
  grid-template-rows: auto;
  grid-template-columns: 1fr;

  @container (min-width: 400px) {
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    grid-auto-columns: 1fr;

    ${DetailWrapper} {
      &:nth-child(odd) {
        border-top: none;
      }
    }
  }
`;

const Detail: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <DetailWrapper>
    <Text size={12} weight="normal">
      {label}
    </Text>
    <Text color="foreground" size={14} weight="medium">
      {value}
    </Text>
  </DetailWrapper>
);

export const DetailsCard: React.FC<DetailsCardProps> = ({ details }) => (
  <StyledCard variant="secondary">
    <DetailsGrid>
      {details.map((detail) => (
        <Detail key={detail.label} {...detail} />
      ))}
    </DetailsGrid>
  </StyledCard>
);
